import { render } from "./EdmNewCampaignDialog.vue?vue&type=template&id=feac75fe"
import script from "./EdmNewCampaignDialog.vue?vue&type=script&lang=js"
export * from "./EdmNewCampaignDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__